class PageLoader extends HTMLElement {
    constructor() {
        super()

        this.customDuration = Number(this.dataset.duration) ?? 0
        
        this.init()
    }

    init() {
        setTimeout(() => {
            if(document.readyState === 'complete' || document.readyState === 'interactive') {
                this.hideLoader()
            } else{
                window.addEventListener('DOMContentLoaded', this.hideLoader.bind(this))
                window.addEventListener('load', this.hideLoader.bind(this))
            }
        }, this.customDuration)

        setTimeout(() => {
            if(!this?.classList?.contains('page-loader--hidden')) {
                console.warn('Page loader timeout: forcing hide')
                this.hideLoader()
            }
        }, 10000)
    }

    hideLoader() {
        if(!!!this) return

        this.classList.add('page-loader--hidden')

        setTimeout(() => {
            this.remove()
        }, 2100) // Match with CSS transition duration
    }
}
customElements.define('page-loader', PageLoader)


class MediaPopup extends HTMLElement {
    constructor() {
        super()
    }

    connectedCallback() {
        this.openBtn = this.querySelector('.media-popup__open')
        this.closeBtn = this.querySelector('.media-popup__close')
        this.media = this.querySelector('video, img, deferred-media-video')

        this.openBtn.addEventListener('click', this.openPopup.bind(this))
        this.closeBtn.addEventListener('click', this.closePopup.bind(this))
    }

    openPopup() {
        this.classList.add('open')
        if(this.media?.tagName === 'VIDEO') this.media.play()
    }

    closePopup() {
        // Pausar video nativo
        if(this.media?.tagName === 'VIDEO') {
            this.media.pause()
        }

        // Pausar iframe de YouTube
        const youtubeIframe = this.querySelector('iframe[src*="youtube.com"]')
        if(youtubeIframe) {
            youtubeIframe.contentWindow.postMessage(
                '{"event":"command","func":"pauseVideo","args":""}',
                '*'
            )
        }

        // Pausar iframe de Vimeo
        const vimeoIframe = this.querySelector('iframe[src*="vimeo.com"]')
        if(vimeoIframe) {
            vimeoIframe.contentWindow.postMessage('{"method":"pause"}', '*')
        }

        this.classList.remove('open')
    }
}
customElements.define('media-popup', MediaPopup)

class SliderComponent extends HTMLElement {
    constructor() {
        super();
        this.slider = this.querySelector('[id^="Slider-"]');
        this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
        this.enableSliderLooping = false;
        this.currentPageElement = this.querySelector('.slider-counter--current');
        this.pageTotalElement = this.querySelector('.slider-counter--total');
        this.prevButton = this.querySelector('button[name="previous"], a[name="previous"]');
        this.nextButton = this.querySelector('button[name="next"], a[name="next"]');
    
        if (!this.slider || !this.nextButton) return;
    
        this.initPages();
        const resizeObserver = new ResizeObserver((entries) => this.initPages());
        resizeObserver.observe(this.slider);
    
        this.slider.addEventListener('scroll', this.update.bind(this));
        this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
        this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    }
  
    initPages() {
        this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
        if (this.sliderItemsToShow.length < 2) return;
        this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
        
        this.slidesPerPage = 1;
        this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
        this.update();
    }
  
    resetPages() {
        this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
        this.initPages();
    }

    updateOnScroll() {
        if(!!!this.sliderItems[this.currentPage - 1]) return
        this.slider.scrollTo({ left: this.sliderItems[this.currentPage - 1].offsetLeft - this.sliderItems[0].offsetLeft });
    }
  
    update() {
        if (!this.slider || !this.nextButton) return;
    
        this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

        if (this.currentPageElement && this.pageTotalElement) {
            this.currentPageElement.textContent = this.currentPage;
            this.pageTotalElement.textContent = this.totalPages;
        }
    
        if (this.enableSliderLooping) return;
    
        if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
            this.prevButton.setAttribute('disabled', 'disabled');
        } else {
            this.prevButton.removeAttribute('disabled');
        }
    
        if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
            this.nextButton.setAttribute('disabled', 'disabled');
        } else {
            this.nextButton.removeAttribute('disabled');
        }
    }
  
    isSlideVisible(element, offset = 0) {
        const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
        return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
    }
  
    onButtonClick(event) {
        event.preventDefault();
        const step = event.currentTarget.dataset.step || 1;
        this.slideScrollPosition =
            event.currentTarget.name === 'next'
            ? this.slider.scrollLeft + step * this.sliderItemOffset
            : this.slider.scrollLeft - step * this.sliderItemOffset;
        this.setSlidePosition(this.slideScrollPosition);
    }
  
    setSlidePosition(position) {
        this.slider.scrollTo({
            left: position,
        });
    }
}
customElements.define('slider-component', SliderComponent);